import template from './afterhours.html';
import controller from './afterhours.controller';
import './afterhours.styl';

const afterhoursComponent = {
  template,
  controller,
  controllerAs: 'afterhours',
  bindings: {
    close: '&',
    dismiss: '&'
  }
};

export default afterhoursComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/afterhours/afterhours.component.js
 **/